import { Messages } from './Messages'
import { GuestSetup } from './GuestSetup'
import { ConversationList } from './ConversationList'
import { ConversationWrapper } from './ConversationWrapper'

export function ConversationGuestSetup() {
  return (
    <ConversationWrapper>
      <GuestSetup />
    </ConversationWrapper>
  )
}

export function ConversationMessages() {
  return (
    <ConversationWrapper>
      <Messages />
    </ConversationWrapper>
  )
}

export function Conversations() {
  return (
    <ConversationWrapper>
      <ConversationList />
    </ConversationWrapper>
  )
}
